export const handleCompleteError = async (error: any, sessionUploadId: string, $indexdb: any) => {
    const errorData = error?.data || error?.response?._data;

    if (errorData?.error === 'PARTS_MISMATCH' && errorData?.missingParts) {
        console.warn(`[Self-Healing] S3 recusou as partes:`, errorData.missingParts);
        
        for (const missing of errorData.missingParts) {
            await $indexdb.upload.markChunkForRetry(sessionUploadId, missing.partNumber, missing.url);
        }
        return true;
    }
    return false;
}